module.exports = __webpack_public_path__ + "media/images/stores3-677300bd2d8eb9751e5fb18727c65494.jpg";